import { render, staticRenderFns } from "./LangList.vue?vue&type=template&id=12ffca1b&scoped=true"
import script from "./LangList.vue?vue&type=script&lang=js"
export * from "./LangList.vue?vue&type=script&lang=js"
import style0 from "./LangList.vue?vue&type=style&index=0&id=12ffca1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ffca1b",
  null
  
)

export default component.exports